import { useSession } from '@/lib/auth'
import FullScreenSpinner from '@/components/layout/FullScreenSpinner'
import ServerUnreachable from '@/components/layout/ServerUnreachable'

/**
 * Ekran strażnika trasy, gdy stan logowania jest jeszcze NIEZNANY
 * (`session.data === undefined`). Wspólny dla wszystkich strażników, bo na
 * /login wolno odesłać wyłącznie po 401 (`data === null`) — błąd sieci przy
 * pierwszym pytaniu nic nie mówi o sesji. Service worker nie podaje już
 * `/api/auth/me` z cache, więc bez tego każdy zimny start bez zasięgu kończył
 * się formularzem logowania przy wciąż ważnej sesji.
 *
 * `errorUpdateCount`, nie `isError`: ponowienie zapytania bez danych cofa je
 * do statusu 'pending'. Przy `isError` ekran błędu ustępował spinnerowi
 * i przycisk „Spróbuj ponownie" znikał razem z fokusem klawiatury.
 */
export default function SessionUnknown() {
  const session = useSession()

  if (session.data === undefined && session.errorUpdateCount > 0) {
    return (
      <ServerUnreachable
        onRetry={() => void session.refetch()}
        retrying={session.isFetching}
      />
    )
  }
  return <FullScreenSpinner />
}
